import Collection from '../collection';
import Priority from '../model/priority';

export default Collection.extend( {
	endpoint: 'priorities?apiVersion=2.0',
	responseAt: 'items',
    model: Priority
} );


// WEBPACK FOOTER //
// ./src/js/collection/priorities.js